<div [ngStyle]="{'z-index': zIndex}" class="teamMoodWidget" #divcontainer>

  <!-- TeamMood Widget -->
  <div class="widget" id="widgetId">

    <!-- TeamMood Widget Small View-->
    <div *ngIf="this.view == 'smallView'">
      <div *ngIf="actualTeamMood != 0" class="mood-img">
        <svg *ngIf="actualTeamMood >= 3.5"><use xlink:href="#full_happy" /></svg>
        <svg *ngIf="actualTeamMood < 3.5 && actualTeamMood >= 2"><use xlink:href="#full_nomotivation" /></svg>
        <svg *ngIf="actualTeamMood < 2"><use xlink:href="#full_unhappy" /></svg>
      </div>
      <div *ngIf="actualTeamMood == 0" class="mood-img">
        <p>No data</p>
      </div>
    </div>

    <!-- TeamMood Widget Home-->
    <div class="teamMoodContainer" *ngIf="this.view != 'smallView'">

        <app-team-mood-voting-avg *ngIf="view == 'showAvg'" (navigate)="onViewChange($event)"></app-team-mood-voting-avg>
        <app-team-mood-feedback *ngIf="view == 'showFeedback'" (navigate)="onViewChange($event)"></app-team-mood-feedback>
        <app-team-mood-data-collection *ngIf="view == 'voting'" (navigate)="onViewChange($event)"></app-team-mood-data-collection>
        <app-team-mood-time-range-chart  *ngIf="view == 'showTimeRange'" (navigate)="onViewChange($event)"></app-team-mood-time-range-chart>
        <app-team-mood-sprint-avg-chart *ngIf="view == 'showTrends'" (navigate)="onViewChange($event)"></app-team-mood-sprint-avg-chart>
        <app-team-mood-question-edit *ngIf="view == 'editQuestion'" (backPressed)="goToLastView()"></app-team-mood-question-edit>

        <div class="container-hr" *ngIf="view !='editQuestion' && view != 'showFeedback' && view != 'voting'" >
          <div class="line-hr"><mat-divider></mat-divider></div>
          <div class="text-hr mat-typography">
            <button mat-icon-button type="button" (click)="editQuestions()" [translate]="'widgets.teamMood.newVote'">
              <mat-icon aria-hidden="false">edit</mat-icon>
            </button>
          </div>
        </div>
    </div>
  </div>

  <svg height="0" width="0" class="smile_frame" fill="none" xmlns="http://www.w3.org/2000/svg">
    <symbol id="full_happy" width="80" height="80" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="50" fill="#0BB852"/>
      <ellipse cx="35" cy="41" rx="7" ry="14" fill="white"/>
      <ellipse cx="64" cy="41" rx="7" ry="14" fill="white"/>
      <ellipse cx="64" cy="41" rx="7" ry="14" fill="white"/>
      <ellipse cx="64" cy="41" rx="5" ry="10" fill="black"/>
      <ellipse cx="35" cy="41" rx="5" ry="10" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3288 64C26.6095 64 26 64.5473 26 65.2666V65.2666C26 75.0605 36.7452 82.9999 50 82.9999C63.2548 82.9999 74 75.0605 74 65.2666V65.2666C74 64.5473 73.3905 64 72.6712 64H27.3288Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M49.8567 81.9997C44.7136 81.9784 39.9538 80.8112 36.0605 78.8403C38.6172 76.5617 43.8523 75 49.8951 75C55.9975 75 61.2763 76.5928 63.8046 78.908C59.9365 80.8379 55.2272 81.9787 50.1433 81.9997H49.8567Z" fill="#C92525"/>
    </symbol>

    <symbol id="full_nomotivation" width="80" height="80" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="50" fill="#FFBF2F"/>
      <path d="M24.7972 67.052C25.2007 65.2998 26.8294 64.1096 28.6213 64.2574L67.7461 67.4842C71.2802 67.7757 74 70.729 74 74.2752V74.2752C74 78.7074 69.8353 81.96 65.5351 80.8862L27.447 71.3751C25.5331 70.8971 24.3546 68.9744 24.7972 67.052V67.052Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M60.7371 78.9997L37 73.0722C39.3885 72.3929 42.2164 72 45.2475 72C53.8073 72 60.7465 75.1338 60.7475 78.9997H60.7371Z" fill="#C92525"/>
      <ellipse cx="36" cy="41" rx="7" ry="14" fill="white"/>
      <ellipse cx="65" cy="41" rx="7" ry="14" fill="white"/>
      <ellipse cx="65" cy="41" rx="5" ry="10" fill="black"/>
      <ellipse cx="36" cy="41" rx="5" ry="10" fill="black"/>
      <g filter="url(#filter0_d)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M29.4596 36H42.5403C41.5339 30.7373 38.9852 27 36 27C33.0148 27 30.466 30.7373 29.4596 36Z" fill="#FFBF2F"/>
      </g>
      <g filter="url(#filter1_d)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M58.4596 36H71.5403C70.5339 30.7373 67.9852 27 65 27C62.0148 27 59.466 30.7373 58.4596 36Z" fill="#FFBF2F"/>
      </g>
      <defs>
        <filter id="filter0_d" x="27.4596" y="26" width="17.0807" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
          </filter>
          <filter id="filter1_d" x="56.4596" y="26" width="17.0807" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
      </defs>
      </symbol>

      <symbol id="full_unhappy" width="80" height="80" viewBox="0 0 100 100">
         <circle cx="50" cy="50" r="50" fill="#FF6159"/>
        <ellipse cx="35" cy="41" rx="7" ry="14" fill="white"/>
        <ellipse cx="35" cy="41" rx="5" ry="10" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M72.6712 83C73.3905 83 74 82.4527 74 81.7334V81.7334C74 71.9395 63.2548 64.0001 50 64.0001C36.7452 64.0001 26 71.9395 26 81.7334V81.7334C26 82.4527 26.6095 83 27.3288 83H72.6712Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M65 81.9997C64.9991 78.1338 58.0598 75 49.5 75C40.9402 75 34.0009 78.1338 34 81.9997H65Z" fill="#C92525"/>
        <g filter="url(#filter0_d)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M42 41C42 33.268 38.866 27 35 27C31.134 27 28 33.268 28 41H42Z" fill="#FF6159"/>
        </g>
        <ellipse cx="64" cy="41" rx="7" ry="14" fill="white"/>
        <ellipse cx="64" cy="41" rx="5" ry="10" fill="black"/>
        <g filter="url(#filter1_d)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M71 41C71 33.268 67.866 27 64 27C60.134 27 57 33.268 57 41H71Z" fill="#FF6159"/>
        </g>
        <defs>
          <filter id="filter0_d" x="26" y="26" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
          </filter>
          <filter id="filter1_d" x="55" y="26" width="18" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="1"/>
            <feGaussianBlur stdDeviation="1"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
          </filter>
        </defs>
    </symbol>
  </svg>
</div>

